import Modal from 'LuxKit/Modal/Modal'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { useIntl } from 'react-intl'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import useLoyaltyPointsPurchaseBestOffer from 'loyalty/hooks/useLoyaltyPointsPurchaseBestOffer'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  rewardPointsDeficit: number
}

function InsufficientLoyaltyPointsModal({ rewardPointsDeficit }: Props) {
  const intl = useIntl()
  const { resolve } = useModalElementContext()
  const loyaltyProgramName = getLoyaltyProgramDisplayName()
  const { offer: bestPurchaseOffer } = useLoyaltyPointsPurchaseBestOffer(rewardPointsDeficit)
  const buyPointsHref = bestPurchaseOffer
    ? `/societe/buy-points?offerId=${encodeURIComponent(bestPurchaseOffer.id)}`
    : '/societe/buy-points'

  const title = intl.formatMessage(
    {
      id: 'cSoJMJXkkp3cSqzQ1q77',
      defaultMessage: 'Top up your {loyaltyProgramName} Points',
      description: 'Title for the modal shown when a user tries to book a Classic Rewards fare without sufficient loyalty points.',
    },
    { loyaltyProgramName },
  )

  const primaryActionText = intl.formatMessage(
    {
      id: '2UpICd_2c1AcbiyrcFFU',
      defaultMessage: 'Top-up {loyaltyProgramName} Points',
      description: 'CTA button on the insufficient loyalty points modal that navigates to the buy points page.',
    },
    { loyaltyProgramName },
  )

  return (
    <Modal
      title={title}
      onClose={() => resolve()}
      primaryActionText={primaryActionText}
      primaryActionTo={buyPointsHref}
      primaryActionTarget="_blank"
    >
      <BodyText variant="medium" colour="neutral-one">
        {intl.formatMessage(
          {
            id: 'i0CN7wirjZA680KbalVL',
            defaultMessage: 'You require an additional {points} {loyaltyProgramName} to book this Rewards fare. Buy more Points, or choose a non-Rewards fare instead.',
            description: 'Body text on the insufficient loyalty points modal telling the user how many more points they need.',
          },
          {
            points: intl.formatNumber(rewardPointsDeficit),
            loyaltyProgramName,
          },
        )}
      </BodyText>
    </Modal>
  )
}

export default InsufficientLoyaltyPointsModal
